import Link from 'next/link';
import styles from './hero-promotion-block.module.scss';

const HeroPromotionBlock = () => {
  return (
    <section
      className={styles.promotion}
      id="jet-card-promotion"
      aria-labelledby="jet-card-promotion-title"
    >
      <div className={`container ${styles.inner}`}>
        <div className={styles.content}>
          <p className={styles.eyebrow}>Limited-time Jet Card offer</p>
          <h2 id="jet-card-promotion-title" className={styles.title}>
            3 free hours on our 25-hour Jet Card
          </h2>
          <p className={styles.description}>
            Available to every client who purchases a Hera Flight Jet Card by
            August 31, 2026.
          </p>
          <ul
            className={styles.aircraft}
            aria-label="Eligible aircraft categories"
          >
            <li>Super Mid: Citation X</li>
            <li>Heavy: GIV &amp; GV</li>
          </ul>
        </div>
        <Link className={styles.cta} href="#form">
          Request the offer
          <svg
            className={styles.arrow}
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            aria-hidden="true"
          >
            <path
              d="M3.75 9h10.5M9.75 5.25 13.5 9l-3.75 3.75"
              stroke="currentColor"
              strokeWidth="1.25"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </Link>
      </div>
    </section>
  );
};

export default HeroPromotionBlock;
